import BouncingLoader from 'components/BouncingLoader/BouncingLoader';
import { LoaderPage } from 'components/BouncingLoader/BouncingLoader.styled';

export const FullPageLoader = () => {
  return (
    <LoaderPage data-testid="full-page-bouncing-loader">
      <BouncingLoader />
    </LoaderPage>
  );
};
